import { useCallback, useState } from "react";
import {
  DocumentTagV2,
  SourceSystemV2,
} from "@hagerty/customer-insurance-gateway-client";
import { apiRoutes } from "../../routing/routes";

export const useDownloadDocument = (
  policyNumber: string,
  source: SourceSystemV2,
  document: DocumentTagV2
) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState<Error>();

  const download = useCallback(async () => {
    setIsDownloading(true);
    const url = apiRoutes.documentUrl(source, document, policyNumber);
    const response = await fetch(url, {
      headers: {
        "content-type": "application/json",
      },
    });

    if (!response || !response.ok) {
      setError(new Error("Couldn't fetch document url"));
      setIsDownloading(false);
      return;
    }

    const documentUrl = await response.text();

    // TODO: download document instead of opening in new window
    // We will need to update CSP to allow download from MCMM asset url
    //
    // const documentName = `${policyNumber}_${document}.pdf`;
    // const didDownload = await downloadDocumentUrl(documentUrl, documentName);
    // setError(
    //   didDownload ? undefined : new Error(`Unable to download ${document}`)
    // );

    window.open(documentUrl, "_blank")?.focus();
    setIsDownloading(false);
    setError(undefined);
  }, [policyNumber]);

  return { download, isDownloading, error };
};
